import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { SessionInfoSingleton } from "../data/singleton/session-info.singleton";
import { Injectable } from "@angular/core";

/**
 * パス「/login_user」以下のAPIに関するクラス
 */
@Injectable({
  providedIn: "root",
})
export class LoginUserApi {
  /**
   * コンストラクタ
   */
  constructor(
    private httpClient: HttpClient,
    private sessionInfoSingleton: SessionInfoSingleton
  ) {}

  /** GET */
  /**
   * ログインユーザー情報の取得
   * - APIパス：/login_user
   * @returns Observable<Object>型のレスポンス
   */
  getLoginUser(): Observable<Object> {
    const url = `${environment.apiUrl}/login_user`;
    return this.httpClient.get(url, {
      headers: new HttpHeaders({
        Authorization: this.sessionInfoSingleton.getIdToken(),
        "Content-Type": "application/json",
      }),
    });
  }
}
